var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137,
    height: 128,
    viewBox: "0 0 137 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.458 49.9307V80.854H83.1128L114.458 49.9307Z",
    fill: "#8FBFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4837 127.801H0.18335V2.42144H60.4837V127.801Z",
    fill: "#4796FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.947 122.601H111.365V39.67H136.947V122.601Z",
    fill: "url(#paint0_linear_6612_1975)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.99 80.79H83.6287",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.552 49.9117V111.618",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.15 49.49H53.3123",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8943 18.6493V111.7",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.527 1.99969H9.74078C8.33518 1.99969 7.21069 3.12416 7.21069 4.52976V109.669C7.21069 111.074 8.33518 112.199 9.74078 112.199H33.2144",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.715 58.7864V4.53009C133.715 3.12448 132.591 2.00002 131.185 2.00002H109.961",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5076 112.199H131.044C132.45 112.199 133.575 111.074 133.575 109.669V67.2197",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8925 2.42119V17.6017",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.153 18.1643H7.63257",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1128 49.9309V111.637",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9565 80.0107L113.896 50.4931",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6645 39.2483H19.1587C17.7531 39.2483 16.6287 38.1238 16.6287 36.7182V32.6419C16.6287 31.2363 17.7531 30.1119 19.1587 30.1119H40.6645C42.0701 30.1119 43.1946 31.2363 43.1946 32.6419V36.7182C43.3351 38.1238 42.0701 39.2483 40.6645 39.2483Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6645 59.0674H19.1587C17.7531 59.0674 16.6287 57.9429 16.6287 56.5373V52.4611C16.6287 51.0555 17.7531 49.931 19.1587 49.931H40.6645C42.0701 49.931 43.1946 51.0555 43.1946 52.4611V56.5373C43.3351 57.9429 42.0701 59.0674 40.6645 59.0674Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7673 73.6858H30.1206",
    stroke: "#DFEDFE",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7673 81.8379H30.1206",
    stroke: "#DFEDFE",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7673 89.8501H30.1206",
    stroke: "#DFEDFE",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7673 98.0024H30.1206",
    stroke: "#DFEDFE",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6612_1975",
    x1: 110.932,
    y1: 53.9779,
    x2: 148.332,
    y2: 131.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DBEFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapping);
export default __webpack_public_path__ + "static/media/mapping.2436a911efe99031aa8b15548eab24c8.svg";
export { ForwardRef as ReactComponent };